var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2853_3597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0991 9.5L10.0991 11.5L9.59912 12.5L7.09912 13H5.59912L2.59912 12L2.09912 10.5L1.09912 9L2.59912 6L3.59912 4L5.09912 2H8.09912L9.09912 3.5L10.0991 5.5L11.0991 6L12.0991 8V9.5Z",
    fill: "#44C530",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59912 9L7.09912 11.5V16",
    stroke: "#7B4A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09912 10.5L8.09912 8",
    stroke: "#7B4A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59912 15L10.0991 16H14.0991L14.5991 15.5L15.0991 14.5L14.0991 13H13.5991L12.5991 11.5H11.0991L9.59912 13L9.09912 14L9.59912 15Z",
    fill: "#78CE71",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2853_3597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0991211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/tree.19b1ec26df8f7071e369d9cd15eb26ae.svg";
export { ForwardRef as ReactComponent };